module.exports = require('./helpers/bundle-url').getBundleURL('01RMl') + "Microsoft.1f15902a.png";